import http from 'hub-http/clients/apiClient';
const BASE_URL = 'multi-currency/v2/currencies/preferred-currencies';
export const fetchPreferredCurrency = () => http.get(BASE_URL).then(result => result.preferredCurrency);